<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="CHAPTER1" id="uAweJHGLNOoQAAYtvs78rTA">Chapter Two</p>
<p class="FIRSTPARAGRAPH">Inside the shed Tilden put down the rubber tubing he’d been toying with and checked his watch. Reaching for his notebook he wrote: ‘sodium thiopental, 100 mg. – ninety-seven minutes’. Tapping on the pad with his pencil, he narrowed his eyes, lost to thought. <span class="italics _idGenCharOverride-1">Allowing for the difference in doses, between the sodium thiopental, a barbiturate, and the Isofluane, an ether, this filly had recovered slower than he’d anticipated. He raised an eyebrow. Maybe an interaction between the two drugs? A clash of anesthetics? That might do it.</span></p>
<p class="Normal">Putting an ear to the door, Tilden smiled. The bitch had finally stopped screaming. He made note of the time, reached for the device he had fitted with an adequate extension for the cleansing then stepped out of the shed and approached the grave. Embalming corpses inside the mortuary was rudimentary. It was important he be proficient in irrigating the living. Especially this one as she lies six feet below the surface of the ground.</p>
<p class="Normal">Her adrenaline had stopped surging. Replaced by the flow of hopelessness. Resigned to her fate, she believed she was hallucinating when someone, or something, darted past the opening above.</p>
<p class="Normal">“Is anyone there?” she hollered.</p>
<p class="Normal">There was no reply.</p>
<p class="Normal">“Anybody? Is anybody up there?” Her voice was coarse, her throat chafed.</p>
<p class="Normal">Still no reply.</p>
<p class="Normal">“Please! If you’re up there . . .”</p>
<p class="Normal">Someone’s head emerged, partially blocking the blistering sunlight. After lingering for a second, maybe two, the head retreated. It was impossible to make out who it was.</p>
<p class="Normal">Within seconds, the figure returned. He was holding an apparatus that resembled an elongated harpoon which he extended into the grave. As adrenalin surged and her heart pounded, she felt a searing sensation on the right side of her neck just before the embalming fluid gushed through the orifice he had made.</p>
<p class="Normal"><span class="italics _idGenCharOverride-1">“Prostitutes,” </span>Tilden muttered eyeing the dying woman. <span class="italics _idGenCharOverride-1">“When I’m done, every one of these vile sluts will be tracked down, cleansed, and obliterated.”</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chap_02.vue?f9fae1ac